import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

//import { Product } from '../models/product';
//import { Scenario } from '../models/scenario';
//import { Router, ActivatedRoute } from '@angular/router';
//import { SwiperModule } from 'angular2-useful-swiper';
//import { AnalyticsService } from "../services/analytics.service";
//import { Tools } from "../tools/tools";
import { AppSettings } from '../../app/app.settings';
import { QuestionnairePage } from '../questionnaire/questionnaire';
import {DataProvider} from '../../providers/data';
/**
 * Generated class for the ProductsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-products',
  templateUrl: 'products.html',
})
export class ProductsPage {
  public productGroups: ProductGroup[] = [];
  public curCountry: string;

  private resultStatsString: string = '';

  constructor(private dataService: DataProvider, public navCtrl: NavController,
              public navParams: NavParams) {
    this.curCountry = dataService.CURRENT_COUNTRY;

    for (let prodType of AppSettings.PROD_TYPES) {
      
      let productIdList = <string>navParams.get(prodType);
      if (productIdList) {
        this.productGroups.push(new ProductGroup(productIdList.split(',').map(p => +p), prodType));
        if (this.resultStatsString)
          this.resultStatsString += '&';

        this.resultStatsString += prodType + '=' + productIdList;
      }
    }
  }

  ionViewDidLoad() {
    //this.analyticsService.emitEvent('result', `result_categories_${this.productGroups.length}`);
    //let productsCount = this.productGroups.reduce((cnt, g) => { return g.productIds.length + cnt; }, 0);
    //    this.analyticsService.emitEvent('result', `result_products_${productsCount}`);
    //   this.analyticsService.emitEvent('result', `result_detailed?${this.resultStatsString}`);
  }

  public restartButtonClick() {
    //this.analyticsService.emitEvent('restart', 'restart_click');
    //this.analyticsService.emitNewUser();
    //this.router.navigate(['/welcome']);
    this.navCtrl.push(QuestionnairePage, { restart: true });
  }
}

class ProductGroup {
  public productIds: number[];
  public type: string;

  constructor(_productIds: number[], _type: string) {
    this.productIds = _productIds;
    this.type = _type;
  }
}



// WEBPACK FOOTER //
// ./src/pages/products/products.ts